import { Modal } from '@arco-design/web-vue'
import { h } from 'vue'
let lastEtag = ''
let hasUpdate = false
let timer = null
checkUpdate()
if (process.env.NODE_ENV === 'production') {
  timer = setInterval(() => {
    checkUpdate()
  }, 300 * 1000)
}
async function checkUpdate() {
  try {
    // 检测前端资源是否有更新
    let response = await fetch(`/manifest.json?v=${Date.now()}`, { method: 'head' })
    // 获取最新的etag
    let etag = response.headers.get('etag')
    hasUpdate = lastEtag && etag !== lastEtag
    lastEtag = etag

    if (hasUpdate) {
      clearInterval(timer)
      let response1 = await (await fetch(`/manifest.json`, { method: 'get' })).json()
      const text = response1.updateMessage
      const content = h(
        'div',
        text.split('&').map((item, i) => h('p', `${i + 1}. ${item}`))
      )
      Modal.warning({
        title: '系统有更新，是否立即刷新网页？',
        titleAlign: 'start',
        content,
        simple: false,
        width: '450px',
        hideCancel: false,
        onOk: () => {
          window.location.reload()
        },
      })
    }
  } catch (e) {
    return Promise.reject(e)
  }
}
